var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublicVisible(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1540_37693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 19.2451C5.40008 19.2451 1.66675 15.5118 1.66675 10.9118C1.66675 6.31178 5.40008 2.57845 10.0001 2.57845C14.6001 2.57845 18.3334 6.31178 18.3334 10.9118C18.3334 15.5118 14.6001 19.2451 10.0001 19.2451ZM3.33341 10.9118C3.33341 11.4201 3.40008 11.9201 3.50841 12.3951L7.49175 8.41178V7.57845C7.49175 6.66178 8.24175 5.91178 9.15841 5.91178V4.30345C5.88341 4.72012 3.33341 7.52012 3.33341 10.9118ZM14.9084 6.41178C14.6917 7.08678 14.0751 7.57845 13.3251 7.57845H12.4917V10.0785C12.4917 10.5368 12.1167 10.9118 11.6584 10.9118H6.65841V12.5785H8.32508C8.78341 12.5785 9.15841 12.9535 9.15841 13.4118V15.0785H10.8251C11.7417 15.0785 12.4917 15.8285 12.4917 16.7451V17.0868C14.9334 16.1035 16.6667 13.7035 16.6667 10.9118C16.6667 9.17845 15.9917 7.59512 14.9084 6.41178Z",
    fill: "#018001"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1540_37693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 20.9121)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicVisible);
export default __webpack_public_path__ + "static/media/PublicVisible.ffa27912caedda5f0e72a9a9ca980011.svg";
export { ForwardRef as ReactComponent };